<template>
<form @submit.prevent="onSubmit">
    <div class="row">
        <div class="col-12 col-sm-12">
            <price-search-contract-length-selector />
            <price-search-annual-mileage-selector/>

            <span class="font-weight-bold">
                        Bérleti díj
                      </span>
            <div class="bootstrap-slider-container">
                <b-form-slider
                    v-model="rangeValue"
                    range
                    :step="1000"
                    :min="min_price"
                    :max="max_price"
                    @slide-stop="updateMinMax()">
                </b-form-slider>
            </div>


        </div>

        <div class="col-12 col-sm-6">
            <label :for="'min_price'">Minimum bérleti díj</label>

            <input
                :id="'min_price'"
                :value="rangeValue[0]"
                type="number"
                :min="min_price"
                :max="max_price"
                step="1000"
                class="form-control form-control-sm"
                @input="onMinPriceInput($event.target.value)"
                @blur="onMinPriceBlur($event.target.value)"
            >
        </div>

        <div class="col-12 col-sm-6">
            <label :for="'max_price'">Maximum bérleti díj</label>
            <input
                :id="'max_price'"
                :value="rangeValue[1]"
                type="number"
                :min="min_price"
                :max="max_price"
                step="1000"
                class="form-control form-control-sm"
                @input="onMaxPriceInput($event.target.value)"
                @blur="onMaxPriceBlur($event.target.value)"
            >

        </div>
    </div>
    <button
        type="submit"
        class="btn btn-block btn-primary mt-3"
    >
        Keresés
    </button>
</form>
</template>


<script>
  import {Vue, Component, Prop} from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  import PriceSearchAnnualMileageSelector from "./PriceSearchAnnualMileageSelector";
  import PriceSearchContractLengthSelector from "./PriceSearchContractLengthSelector";

  const priceSearchModule = namespace('price_search');

  function paramsToObject(entries) {
    let result = {};
    for (let entry of entries) { // each 'entry' is a [key, value] tupple
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  }

  @Component({
    components: {
      PriceSearchContractLengthSelector,
      PriceSearchAnnualMileageSelector}
  })

  export default class PriceSearchForm extends Vue {
    
    @Prop(String) url;
    @Prop(Number) max_price;
    @Prop(Number) min_price;

    @priceSearchModule.Getter('getAnnualMileage') annualMileage;
    @priceSearchModule.Getter('getContractLength') contractLength;
    @priceSearchModule.State('filters') filters;
    @priceSearchModule.Mutation('setFilters') setFilters;
    @priceSearchModule.Mutation('setAnnualMileage') setAnnualMileage;
    @priceSearchModule.Mutation('setContractLength') setContractLength;

    initialPayment = 10;
    rangeValue = null;

    created() {

      const params = new URLSearchParams(location.search);
      const filters = paramsToObject(params.entries());

      this.rangeValue = [
        filters.min_price ? parseInt(filters.min_price) : this.min_price,
        filters.max_price ? parseInt(filters.max_price) : this.max_price
      ];

      filters.annualMileage = filters.annualMileage?filters.annualMileage:this.annualMileage;
      filters.contractLength = filters.contractLength?filters.contractLength:this.contractLength;

      this.setAnnualMileage(parseInt(filters.annualMileage));
      this.setContractLength(parseInt(filters.contractLength));

      this.setFilters({
        ...filters,
        min_price: this.rangeValue[0],
        max_price: this.rangeValue[1]
      });

    }

    onSubmit() {

      const url = new URL(this.url);
      for (let key in this.filters) {
          url.searchParams.append(key, this.filters[key]);
      }

      url.searchParams.set('page', "1");

      location.href = url.href

    }

    updateMinMax() {
      this.filters.min_price = this.rangeValue[0];
      this.filters.max_price = this.rangeValue[1];
    }

    onMinPriceInput(value) {
      const numValue = parseInt(value) || this.min_price;
      if (numValue >= this.min_price && numValue <= this.max_price && numValue <= this.rangeValue[1]) {
        this.rangeValue[0] = numValue;
        this.updateMinMax();
      }
    }

    onMinPriceBlur(value) {
      const numValue = parseInt(value) || this.min_price;
      // Ensure min doesn't exceed max
      if (numValue > this.rangeValue[1]) {
        this.rangeValue[0] = this.rangeValue[1];
      } else if (numValue < this.min_price) {
        this.rangeValue[0] = this.min_price;
      } else {
        this.rangeValue[0] = numValue;
      }
      this.updateMinMax();
    }

    onMaxPriceInput(value) {
      const numValue = parseInt(value) || this.max_price;
      if (numValue >= this.min_price && numValue <= this.max_price && numValue >= this.rangeValue[0]) {
        this.rangeValue[1] = numValue;
        this.updateMinMax();
      }
    }

    onMaxPriceBlur(value) {
      const numValue = parseInt(value) || this.max_price;
      // Ensure max doesn't go below min
      if (numValue < this.rangeValue[0]) {
        this.rangeValue[1] = this.rangeValue[0];
      } else if (numValue > this.max_price) {
        this.rangeValue[1] = this.max_price;
      } else {
        this.rangeValue[1] = numValue;
      }
      this.updateMinMax();
    }
  }
</script>
